<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div id="square7" class="square square-7" style="transform: perspective(500px) rotateY(11.45deg) rotateX(0.123333deg);"></div>
        <div id="square8" class="square square-8" style="transform: perspective(500px) rotateY(11.45deg) rotateX(0.123333deg);"></div>
        <div class="card card-register">
          <div class="card-header">
            <img class="card-img" src="../assets/img/square-purple-1.png" alt="Card image" title="" style="">
            <h4 class="card-title">register</h4>
          </div>
          <form class="form" @submit.prevent="submit">
            <div class="card-body">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="ion ion-md-person"></i>
                    </div>
                  </div>
                  <input type="text" placeholder="Username" class="form-control" v-model="user.username">
                </div>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="ion ion-md-lock"></i>
                    </div>
                  </div>
                  <input type="password" class="form-control" placeholder="Password" v-model="user.password">
                </div>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="ion ion-md-mail"></i>
                    </div>
                  </div>
                  <input type="text" class="form-control" placeholder="Email (optional)" v-model="user.email">
                </div>
              <div class="text-danger">
                {{ registerError }}
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" href="javascript:void(0)" class="btn btn-success btn-round btn-lg">Register</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="register-bg"></div>
    <div id="square1" class="square square-1" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
    <div id="square2" class="square square-2" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
    <div id="square3" class="square square-3" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
    <div id="square4" class="square square-4" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
    <div id="square5" class="square square-5" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
    <div id="square6" class="square square-6" style="transform: perspective(500px) rotateY(28.625deg) rotateX(0.308333deg);"></div>
  </div>
</template>
<script>
export default {

  name: 'Register',

  data () {
    return {
      user: {
        username: '',
        password: '',
        email: '',
      }
    }
  },

  computed: {
    registerError () {
      return this.$store.state.users.registerError
    }
  },

  methods: {
    submit () {
      this.$store.dispatch('users/registerUser', this.user)
    }
  }
}
</script>

<style lang="css" scoped>
.input-group:focus-within .input-group-prepend .input-group-text,
.input-group:focus-within .input-group-append .input-group-text {
  background-color: #ffffff;
  border-color: #e14eca;
  background-color: transparent;
  border-color: #e14eca;
}
.card-header {
  display: flex;
  justify-content: flex-end;
}
.card-register .card-header img {
  margin-left: initial;
  left: initial;
  margin-right: -50px;
  right: 0;
}
</style>
